// Import and register all your controllers from the importmap under controllers/*

import { application } from "./application"
// import { registerControllers } from "@hotwired/stimulus-loading"
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers"

// Eager load all controllers defined in the import map under controllers/**/*_controller
// import { eagerLoadControllersFrom } from "@hotwired/stimulus-loading"

eagerLoadControllersFrom("controllers", application)

// Lazy load controllers as they appear in the DOM (remember not to preload controllers in import map!)
// import { lazyLoadControllersFrom } from "@hotwired/stimulus-loading"
// lazyLoadControllersFrom("controllers", application)

// Register all controllers in the controllers directory
const context = require.context(".", true, /\.js$/)
application.load(definitionsFromContext(context))
